enum ReleaseStatus {
    WITHDRAWN = "withdrawn",
    RELEASED = "released",
    RERELEASED = "rereleased",
};

export {ReleaseStatus};